import { render, staticRenderFns } from "./_DoLink.vue?vue&type=template&id=4f3dda80"
import script from "./_DoLink.vue?vue&type=script&lang=js"
export * from "./_DoLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports